module.exports = __webpack_public_path__ + "img/button1.29ade077.png";